import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  CardBatchSelected,
  CardNumberChanged,
  CardTypeChanged,
  CloseAssignCardModal,
  CloseCardLostDestroyModal,
  GetActiveReservedPointsSuccess,
  GetCardBatchesSuccess,
  GetCategoriesSuccess,
  GetCouponsetSuccess,
  GetInactiveReservedPointsSuccess,
  GetLoyaltyMemberDataSuccess,
  GetMemberSchemasSuccess,
  GetMemberSourcesSuccess,
  GetMemberStatusesSuccess,
  GetMemberStoresSuccess,
  InitPointReservationsColumns,
  MemberCardsAssignModal,
  ObservationsChanged,
  OpenCardLostDestroyModal,
  PACardbatchChanged,
  ShowProcessedChanged,
  ViewMemberSearchPage,
} from '../actions/lmembers-summary.actions';
import { MembersInfoState } from '../models/member-summary.models';

const initialState: MembersInfoState = {
  member: null,
  schemas: [],
  stores: [],
  couponSets: [],
  memberSources: [],
  categories: [],
  memberStatuses: [],
  memberName: '',
  birthDate: '',
  mobile: '',
  email: '',
  qivosID: '',
  cardNumber: '',
  paCardbatch: '',
  cardAssignManually: true,
  cardBatches: [],
  selectedCardBatch: null,
  observations: '',
  selectedLoyaltyCardId: null,
  schema: 0,
  registrationStore: 0,
  memberSource: 0,
  category: 0,
  memberStatus: 0,
  totalPoints: 0,
  reservedPoints: 0,
  activePointReservationsColumns: {},
  inactivePointReservationsColumns: {},
  activeReservedPoints: [],
  showProcessed: false,
  inactiveReservedPoints: [],
  availablePoints: 0,
  lifetimePoints: 0,
  expirablePoints: 0,
  active: false,
};

// GetDetailedRFMAnalysisSuccess
// GetCouponsetSuccess
// GetSeveritiesSuccess
// GetStatusesSuccess
// GetAssignmentsSuccess
// GetCommunicationChannelsSuccess
// GetAvailableLanguagesSuccess
// GetCustomerSuccess
// FindCampaignsSuccess
// GetCSIChartsSuccess
// GetLifecycleChartsSuccess
// GetMemberSourcesSuccess
// GetLoyaltyCardSuccess
// GetCustomerReportingSuccess
// GetMemberScannedFormSuccess

export const MemberInfoReducer = createReducer(
  initialState,
  on(GetLoyaltyMemberDataSuccess, (state, { res }) => ({
    ...state,
    member: res,
    memberName: '',
    birthDate: res?.person?.dateOfBirth ?? '',
    mobile: res?.person?.telephoneList?.[0]?.telephoneNumber ?? '',
    email: res?.person?.emailList?.[0]?.emailAddress ?? '',
    qivosID: res?.systemCode ?? '',
    cardNumber: res?.memberDashDetails?.loyaltyCardNumber ?? '',
    schema: res?.memberDashDetails?.loyaltySchemaId ?? '',
    registrationStore: res?.memberDashDetails?.registrationStoreId ?? '',
    memberSource: res?.memberDashDetails?.memberSourceId ?? '',
    category: res?.memberDashDetails?.memberCategoryId ?? '',
    memberStatus: res?.statusId ?? '',
    totalPoints: res?.memberPointsInfo?.totalPoints ?? '',
    reservedPoints: res?.memberPointsInfo?.reservedPoints ?? '',
    availablePoints: res?.memberPointsInfo?.availablePoints ?? '',
    lifetimePoints: res?.memberPointsInfo?.lifetimePoints ?? '',
    expirablePoints: res?.memberPointsInfo?.expirablePoints ?? '',
    active: res?.deleteFlag === null || res?.deleteFlag === undefined ? false : !res?.deleteFlag,
  })),
  on(GetMemberSourcesSuccess, (state, { res }) => ({
    ...state,
    memberSources: res,
  })),
  on(GetCategoriesSuccess, (state, { res }) => ({
    ...state,
    categories: res,
  })),
  on(GetMemberSchemasSuccess, (state, { res }) => ({
    ...state,
    schemas: res,
  })),
  on(GetMemberStatusesSuccess, (state, { res }) => ({
    ...state,
    memberStatuses: res,
  })),
  on(GetMemberStoresSuccess, (state, { res }) => ({
    ...state,
    stores: res,
  })),
  on(GetCouponsetSuccess, (state, { res }) => ({
    ...state,
    couponSets: res,
  })),
  on(InitPointReservationsColumns, (state, { pointReservationsColumns }) => ({
    ...state,
    inactivePointReservationsColumns: pointReservationsColumns,
    activePointReservationsColumns: {
      ...pointReservationsColumns,
      ['Action']: 'delete',
    },
  })),
  on(GetActiveReservedPointsSuccess, (state, { res }) => ({
    ...state,
    activeReservedPoints: res,
  })),
  on(GetInactiveReservedPointsSuccess, (state, { res }) => ({
    ...state,
    inactiveReservedPoints: res,
  })),
  on(ShowProcessedChanged, (state) => ({
    ...state,
    showProcessed: !state.showProcessed,
  })),
  on(MemberCardsAssignModal, (state) => ({
    ...state,
    cardNumber: '',
    cardAssignManually: true,
    selectedCardBatch: null,
  })),
  on(CardTypeChanged, (state) => ({
    ...state,
    cardAssignManually: !state.cardAssignManually,
    cardNumber: '',
    selectedCardBatch: null,
  })),
  on(CardNumberChanged, (state, { cardNumber }) => ({
    ...state,
    cardNumber,
  })),
  on(PACardbatchChanged, (state, { paCardbatch }) => ({
    ...state,
    paCardbatch,
  })),
  on(GetCardBatchesSuccess, (state, { cardBatches }) => ({
    ...state,
    cardBatches,
  })),
  on(CardBatchSelected, (state, { selectedCardBatch }) => ({
    ...state,
    selectedCardBatch,
  })),
  on(CloseAssignCardModal, (state) => ({
    ...state,
    cardAssignManually: true,
    cardNumber: '',
    selectedCardBatch: null,
  })),
  on(ObservationsChanged, (state, { observations }) => ({
    ...state,
    observations,
  })),
  on(OpenCardLostDestroyModal, (state, { loyaltyCardId }) => ({
    ...state,
    selectedLoyaltyCardId: loyaltyCardId,
  })),
  on(CloseCardLostDestroyModal, (state) => ({
    ...state,
    observations: '',
    selectedLoyaltyCardId: null,
  })),

  on(ActiveComponentChanged, (state, { activeComponent }) =>
    activeComponent === 'AllCustomersComponent' || activeComponent === 'MemberSearchComponent'
      ? {
          ...state,
        }
      : { ...initialState },
  ),

  // Reset member data when navigating back to search so details tabs don't show stale data on next open
  on(ViewMemberSearchPage, () => ({ ...initialState })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
